import { TDevicesStore } from '@monorepo/types';
import produce from 'immer';
import { DevicesStoreActionTypes, TDevicesStoreActions } from './devices-db.actions';

export const DEVICES_STORE_INITIAL_STATE: TDevicesStore = {
  devicesDB: {
    pairedDeviceInfo: {
      list: [],
    },
    connectedDeviceInfo: {
      BLUETOOTH: null,
      RFID: null,
      NFC: null,
      scanMode: 'multi_tag',
    },
  },
};

export function DeviceStoreStateReducer(
  state: TDevicesStore = DEVICES_STORE_INITIAL_STATE,
  action: TDevicesStoreActions,
): TDevicesStore {
  switch (action.type) {
    case DevicesStoreActionTypes.SetDevicesStore: {
      return produce(state, (draft) => {
        draft.devicesDB = action.devicesDB;
      });
    }
    default:
      return state;
  }
}
